import { BlocksIconCva } from 'blocks-nextjs/blocks-web-components/components/icon/icons/cva';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconCva = createComponent({
  react: React,
  tagName: 'cat-icon-cva',
  elementClass: BlocksIconCva
});
